export default __webpack_public_path__ + "static/media/1406.efa2a521.png";